<template>
  <div style="position:relative; align-self: center;">
  	<div tabindex="-1" class="button" @click="openSendTokensForm" :data-tooltip="$t('tokens_modal.button_send_tokens_tooltip')" ontouchstart>
  		<div class="icon"></div>
  	</div>
    <SendTokensModal v-if="open_modal" @cancel="open_modal = !open_modal" :model="model" :post="post" />
  </div>
</template>
<script>
import SendTokensModal from "../SendTokensModal"
export default {
  components: {SendTokensModal},
	props: {
		model: {
        	type: Object,
         	required: true
        },
    post: {
       	type: Object,
       	required: true
      },
    },
    data() {
      return {
        open_modal: false,
      }
    },
    methods: {
    	openSendTokensForm() {
        if (this.$auth.check()) {
          this.open_modal = true;
          return;
        }
        this.$router.push({ name: "purchase.tokens"});
    	}
    }
}
</script>
<style scoped lang="scss">
@import '../../styles/variables';

.button {
  /*width: 50px;
  height: 20px;*/
  border-radius: 5px;
  text-align: center;
  /*background: #cccccc;*/
  cursor: pointer;
  // margin-bottom: 5px;
  overflow: hidden;
  font-weight: bold;
}

.icon {
  vertical-align: bottom;
  position: relative;

  $SIZE: 34px;

  width: $SIZE;
  height: $SIZE;
  background-size: contain;
  // background-repeat: no-repeat;
  background-position: center;
  background-image: var(--img-btn-min-dolar);
}

.button:hover::before,
.button:active::before,
.button:focus::before {
  content: attr(data-tooltip);
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateX(-100%) translateY(-50%);
  background-color: black;
  color: white;
  border-radius: 0.5rem;
  padding: 0.3rem 0.5rem;
  font-size: 0.8rem;
}
/*.button::before,
.button::after {
  position: absolute;
  top: -.25rem;
  content: '';
  left: 50%;
  transform: translateX(-50%) translateY(-100%) scale(0);
}

.button::before {
  content: attr(data-tooltip);
  height: 25px;
  padding: .5rem;
  border-radius: .3rem;
  width: max-content;
  max-width: 100%;
  background-color: black;
}
*/
/*
.button:hover::before,
.button:active::before,
.button:focus::before  {
  transform: scale(1);
}*/
/*.button:hover::before {
  content: attr(data-tooltip);
  position: absolute;
  top: -10px;
}*/
</style>
